export function addResizeObserver(
  element: Element | null | undefined,
  cb: () => void,
) {
  if (element == null) {
    return;
  }

  if (typeof ResizeObserver === 'undefined') {
    return;
  }

  const resizeObserver = new ResizeObserver(cb);
  resizeObserver.observe(element);

  return () => {
    resizeObserver.disconnect();
  };
}
